import { ErrorIcon } from '@ramsey-design-system/icons';
import Alert from '@ramsey-design-system/alert';
import Text from '@ramsey-design-system/text';

interface ErrorMessageProps {
  errorMessage: string;
}

export function ErrorMessage({ errorMessage }: Readonly<ErrorMessageProps>) {
  return (
    <Alert
      data-testid="error-message"
      role="alert"
      aria-label="alert"
      className="mb-4"
      fullWidth={true}
      color="negative"
      icon={ErrorIcon}
    >
      <Text className="text-3 sm:text-4">{errorMessage}</Text>
    </Alert>
  );
}
